var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonDrop',{attrs:{"url":"/trade/currency/list","autoDefault":false,"disabled":_vm.disabled,"valName":"name","size":"mini"},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }